import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Icon } from 'component-lib';
import { Challenge } from 'types/graphql';

export type SplashScreenChallenge = Pick<Challenge, 'title'>;

export interface SplashScreenChallengeListProps {
  challenges: SplashScreenChallenge[];
}

export const SplashScreenChallengeList = ({ challenges }: SplashScreenChallengeListProps) => {
  return (
    <CustomScrollbarSection tw="text-gray-30 p-3 border-2 border-gray-50 rounded-sm overflow-y-auto space-y-2">
      {challenges.map((challenge, index) => (
        <div tw="flex items-center space-x-2" key={`challenge-${index}`}>
          {index === 0 ? (
            <Icon name="padlock-unlocked" tw="font-normal text-success text-3xl" />
          ) : (
            <Icon name="padlock-locked" tw="font-normal text-3xl" />
          )}
          <p>{challenge.title}</p>
        </div>
      ))}
    </CustomScrollbarSection>
  );
};

const CustomScrollbarSection = styled.section`
  &::-webkit-scrollbar {
    ${tw`w-1 bg-transparent`}
  }
  ::-webkit-scrollbar-thumb {
    ${tw`bg-gray-50 rounded border-2 border-solid border-transparent`}
    background-clip: content-box;
  }
`;
